<template>
  <div class="agent-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="140px">
        <el-form-item label="账号:" prop="name">
          <el-input v-model="params.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input v-model="params.password" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色:" prop="role">
          <el-select v-model="params.role" placeholder="请选择角色">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :value="item.role"
              :label="item.role"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商区码:" prop="discCode">
          <el-input v-model="params.discCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            type="textarea"
            style="width:220px"
            :autosize="{ minRows: 3, maxRows: 6}"
            v-model="params.remark"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      roleList:[],
      // 新增、编辑商区代理商参数
      params: {
        parent:"",
        name: "",
        password: "",
        role: "",
        dividendRatio: null,
        discCode: "",
        remark: "",
      },
      // 验证规则
      rules: {
        name: [{ required: true, message: "必填", trigger: "blur" }],
        password: [{ required: true, message: "必填", trigger: "blur" }],
        role: [{ required: true, message: "必填", trigger: "blur" }],
        // discType: [{ required: true, message: "必填", trigger: "blur" }],
        dividendRatio: [{ required: true, message: "必填", trigger: "blur" }]
      }
    };
  },

  methods: {
    getAuthorList() {
      API.getRoleList({
          discCode: this.params.parent, //商区码 [必传]
          pageNumber: 1, //当前页 [必传]
          pageSize: 50 //每页条数 [必传]
        })
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.roleList = res.data.list;
          }
        });
    },
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
           this.addAgent();
      }});
    },
    // 新增商区代理商
    addAgent() {
      API.addSubAgent(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success"
            });
            this.$emit("handlerAddDistrict");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("新增失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        agent: "",
        dividendRatio: 0,
        // inviteLink: '',
        remark: ""
      };
      this.parent = "";
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(parent) {
      this.dialogVisible = true;
      this.params.parent = parent;
      this.title = "新增商区代理";
      this.getAuthorList()
    }
  }
};
</script>

<style lang="scss">
.agent-action-box {
  .el-input {
    width: 220px;
  }
  .checked {
    margin-left: 10px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  .el-pagination {
    margin-top: 0 !important;
  }
}
</style>
